<template>
  <a-drawer width="35%" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>发放优惠券</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
      <a-form-model-item label="选择优惠券" prop="couponId">
        <a-select
          v-model="form.couponId"
          placeholder="请选择优惠券"
          show-search
          option-filter-prop="children"
          :loading="couponLoading"
          allow-clear
        >
          <a-select-option v-for="item in couponOptions" :key="item.id" :value="item.id">
            {{ getCouponLabel(item) }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="发放方式" prop="distributeType">
        <a-radio-group v-model="form.distributeType">
          <a-radio :value="1">
            按手机号发放
          </a-radio>
          <a-radio :value="2">
            全部雇主用户发放
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="form.distributeType === 1" label="手机号" prop="mobilesText">
        <a-textarea
          v-model="form.mobilesText"
          placeholder="请输入手机号，支持逗号、换行、空格分隔"
          :auto-size="{ minRows: 4, maxRows: 8 }"
          allow-clear
        />
        <div class="form-tip">支持逗号、换行、空格分隔多个手机号</div>
      </a-form-model-item>
      <a-form-model-item v-else label="提示">
        <a-alert message="将发放给所有雇主端用户" type="info" show-icon />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            确认发放
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { listCoupon, distributeCoupon } from '@/api/coupon/coupon'

export default {
  name: 'DistributeForm',
  data () {
    return {
      open: false,
      couponLoading: false,
      submitLoading: false,
      couponOptions: [],
      form: {
        couponId: undefined,
        distributeType: 1,
        mobilesText: ''
      },
      rules: {
        couponId: [
          { required: true, message: '请选择优惠券', trigger: 'change' }
        ],
        distributeType: [
          { required: true, message: '请选择发放方式', trigger: 'change' }
        ],
        mobilesText: [
          { validator: this.validateMobilesText, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onClose () {
      this.cancel()
    },
    reset () {
      this.form = {
        couponId: undefined,
        distributeType: 1,
        mobilesText: ''
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleOpen () {
      this.reset()
      this.open = true
      this.getCouponOptions()
    },
    cancel () {
      this.open = false
      this.reset()
    },
    getCouponOptions () {
      this.couponLoading = true
      listCoupon().then(response => {
        const data = response && response.data
        this.couponOptions = Array.isArray(data) ? data : ((data && data.records) || [])
      }).finally(() => {
        this.couponLoading = false
      })
    },
    getCouponLabel (item) {
      return `${item.name || '未命名优惠券'} | ¥${item.price || 0} | 满${item.require || 0}可用`
    },
    parseMobiles (value) {
      return Array.from(new Set((value || '')
        .split(/[\s,，]+/)
        .map(item => item.trim())
        .filter(item => item)))
    },
    validateMobilesText (rule, value, callback) {
      if (this.form.distributeType !== 1) {
        callback()
        return
      }
      if (this.parseMobiles(value).length === 0) {
        callback(new Error('请输入至少一个手机号'))
        return
      }
      callback()
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        const mobiles = this.form.distributeType === 1 ? this.parseMobiles(this.form.mobilesText) : []
        this.submitLoading = true
        distributeCoupon({
          couponId: this.form.couponId,
          distributeType: this.form.distributeType,
          mobiles: mobiles
        }).then(response => {
          const count = response && response.data !== undefined ? response.data : 0
          this.$message.success(`成功发放 ${count} 张`, 3)
          this.open = false
          this.$emit('ok')
          this.reset()
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.form-tip {
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
}
</style>
